import { Card, Button } from "react-bootstrap";
import "../styles/ConformationBox.css";

export function ConfirmationBox({ title = "Are you sure you want to proceed?", onConfirm, onCancel, setConformBox }) {
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    else if (setConformBox) setConformBox(false);
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    else if (setConformBox) setConformBox(false);
  };

  return (
    <div className="confirm-overlay">
      <Card className="confirm-card" role="dialog" aria-modal="true" aria-labelledby="confirm-title">
        <Card.Body className="text-center">
          <div className="confirm-icon" aria-hidden="true">!</div>
          <h6 id="confirm-title" className="confirm-text">{title}</h6>
          <div className="d-flex justify-content-center gap-3 mt-3">
            <Button variant="primary" className="confirm-yes" onClick={handleConfirm}>Yes</Button>
            <Button variant="secondary" className="confirm-no" onClick={handleCancel}>No</Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
